import { PipelineStatusItem } from '../types/monitoring';
import { Badge } from '@/components/ui/badge';
import { formatDate } from '@/lib/utils';

const statusConfig = {
  running: { label: 'Running', color: 'bg-blue-500' },
  completed: { label: 'Completed', color: 'bg-emerald-500' },
  failed: { label: 'Failed', color: 'bg-red-500' },
  idle: { label: 'Idle', color: 'bg-slate-400' },
};

interface PipelineStatusCardProps {
  pipeline: PipelineStatusItem;
}

export default function PipelineStatusCard({ pipeline }: PipelineStatusCardProps) {
  const status = statusConfig[pipeline.status];

  return (
    <div className="rounded-lg border bg-card p-4 shadow-sm">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-sm font-semibold">{pipeline.name}</h3>
          {pipeline.lastRunAt && (
            <p className="text-xs text-muted-foreground">
              Last run {formatDate(pipeline.lastRunAt)}
            </p>
          )}
        </div>
        <Badge variant="outline">{status.label}</Badge>
      </div>
      <div className="mt-3">
        <div className="flex items-center justify-between text-xs text-muted-foreground">
          <span>{pipeline.progress}%</span>
          {pipeline.durationSec ? <span>{pipeline.durationSec}s</span> : null}
        </div>
        <div className="mt-1 h-2 w-full rounded-full bg-muted">
          <div
            className={`h-2 rounded-full ${status.color}`}
            style={{ width: `${pipeline.progress}%` }}
          />
        </div>
      </div>
    </div>
  );
}
